'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Debug = _interopDefault(require('debug'));
var slate = require('slate');

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var emptyDocument = {
  object: "value",
  document: {
    object: "document",
    data: {},
    nodes: [{
      object: "block",
      type: "paragraph",
      isVoid: false,
      data: {},
      nodes: [{
        object: "text",
        text: "",
        marks: []
      }]
    }]
  }
};

/**
 * Returns true if path1 and path2 refer to the same place, false otherwise.
 * @param {Array<number>} path1
 * @param {Array<number>} path2
 * @return {boolean}
 */
var samePath = function samePath(path1, path2) {
  return slate.PathUtils.compare(path1, path2) === 0;
};

/**
 * Returns true if path1 refers to an ancestor of path2, false otherwise.
 * @param {Array<number>} path1
 * @param {Array<number>} path2
 * @return {boolean}
 */
var isParentPath = function isParentPath(path1, path2) {
  return slate.PathUtils.isAbove(path1, path2);
};

/**
 * Returns true if a change to changedPath requires an adjustment to
 * path. For example, if changedPath removed a node before path, path
 * will need to be adjusted to point to the correct location.
 *
 * @param {Array<number>} changedPath The path changed by the operation we're transforming against
 * @param {Array<number>} path The path we may need to adjust
 * @param {boolean} affectsEqualPaths If our path was changed, do we need to adjust?
 * @return {boolean}
 */
var canAffectPath = function canAffectPath(changedPath, path, affectsEqualPaths) {
  // If a node's parent is one of our ancestor, and the node is at a
  // position before us, we'll need to be adjusted.
  return isParentPath(changedPath.slice(0, -1), path) && changedPath.get(changedPath.size - 1) < path.get(changedPath.size - 1) || isParentPath(changedPath, path) || samePath(changedPath, path) && affectsEqualPaths;
};

/**
 * Returns true if a split_node operation can affect our path, false
 * otherwise. This is different than canAffectPath, because we need to
 * check one level deeper, to `position` / `offset.`
 *
 * @param {Array<number>} path The path we may need to adjust
 * @param {Array<number>} position The position or offset of our node
 * @param {Operation} op The split_node op we're transforming against
 * @param {boolean} affectsEqualPaths If our path was split at our position, do we need to adjust?
 * @return {boolean}
 */
var splitCanAffectPath = function splitCanAffectPath(path, position, op, affectsEqualPaths) {
  var splitAfterUs = isParentPath(op.path, path) && path.get(op.path.size) < op.position;
  var splitParentBeforeUs = path.size > op.path.size && op.position <= path.get(op.path.size);
  var splitUsBeforeOurPosition = path.size === op.path.size && (op.position < position || op.position === position && affectsEqualPaths);
  return !splitAfterUs && canAffectPath(op.path, path, splitParentBeforeUs || splitUsBeforeOurPosition);
};

/**
 * Adjust the path component at index `index` by `amount`. For
 * example, to turn [0, 0, 1, 1] into [0, 0, 2, 1], you'd call
 * `adjustPath([0, 0, 1, 1], 1, 2)`
 *
 * @param {Array<number>} path The path that needs adjusting
 * @param {number} amount The amount (positive or negative) to adjust the path by
 * @param {number} index The index of path that will be adjusted by amount
 * @returns {Array<number>}
 */
var adjustPath = function adjustPath(path, amount, index) {
  return slate.PathUtils.increment(path, amount, index);
};

/**
 * True if removing `removedPath` would also remove `path`, false
 * otherwise.
 *
 * @param {Array<number>} path Our path
 * @param {Array<number>} removedPath The path that was removed
 */
var pathWasRemoved = function pathWasRemoved(path, removedPath) {
  return isParentPath(removedPath, path) || samePath(removedPath, path);
};

/**
 * Converts offset and length into start and end, to more easily
 * compare boundaries.
 * @param {number} offset
 * @param {number} length
 * @returns {{start: number, end: number, length: number}}
 */
var bounds = function bounds(offset, length) {
  return {
    start: offset,
    end: offset + length,
    length: length
  };
};

/**
 * Get the start and end positions of an insert_text / remove_text operation.
 * @param {Operation} op
 * @returns {{start: number, end: number, length: number}}
 */
var textOpBounds = function textOpBounds(op) {
  return bounds(op.offset, op.text.length);
};

// Marks passed in set_mark ops are { type: <string>, data:
// <Immutable.Map> }, Marks passed in insert/remove_mark ops are Mark
// objects, etc.  so we need a custom equals function to compare them.
function equalMarks(mark, otherMark) {
  return mark.type === otherMark.type && mark.data.equals(otherMark.data);
}

// newPath on Slate's move operations act differently if you're moving
// nodes around underneath a parent, vs. moving nodes between
// subtrees. For example, if you're moving node [0, 3] to [0, 6], the
// node will end up at [0, 6]. But if you're moving node [0, 3] to [0,
// 4, 1], the node will actually end up at [0, 3, 1]. In one case,
// newPath points at the new position of the node -- in the other
// case, it points at the new position *before* the node was removed.
//
// Handling the difference between these two situations require a
// bunch of flaky edge case handling. Instead, if we treat every
// newPath as pointing to "the target position before the node is
// removed", the code works more consistently, and is easier to reason
// about.
var moveNodeOpWithConsistentTargetPath = function moveNodeOpWithConsistentTargetPath(op) {
  if (samePath(op.path.slice(0, -1), op.newPath.slice(0, -1)) && canAffectPath(op.path, op.newPath, true)) {
    return op.set("newPath", adjustPath(op.newPath, 1, op.path.size - 1));
  }
  return op;
};

// This inverses moveNodeOpWithConsistentTargetPath, to make the op
// apply correctly to a Slate document. If you called
// moveNodeOpWithConsistentTargetPath, you must call this before you
// return the op from your function.
var moveNodeOpWithSlateTargetPath = function moveNodeOpWithSlateTargetPath(op) {
  if (samePath(op.path.slice(0, -1), op.newPath.slice(0, -1)) && canAffectPath(op.path, op.newPath, false)) {
    return op.set("newPath", adjustPath(op.newPath, -1, op.path.size - 1));
  }
  return op;
};
var adjustPathForNodeSplit = function adjustPathForNodeSplit(path, position, op, affectsEqualPaths) {
  var adjustedPath = path;
  if (splitCanAffectPath(path, position, op, affectsEqualPaths)) {
    adjustedPath = adjustPath(path, 1, op.path.size - 1);
  }
  if (isParentPath(op.path, path)) {
    if (op.position > path.get(op.path.size)) return adjustedPath;

    // In our hierarchy, we can imagine a node being inserted
    // before our ancestor, and a bunch of nodes moved to that new
    // node. So we have to adjust our path to match the new
    // situation. Check out the tests for an example.
    return adjustPath(adjustedPath, -op.position, op.path.size);
  }
  return adjustedPath;
};
var adjustPositionForNodeSplit = function adjustPositionForNodeSplit(path, position, op, affectsEqualPaths) {
  if (samePath(path, op.path)) {
    if (position < op.position) return position;
    if (position === op.position && !affectsEqualPaths) return position;
    return position - op.position;
  }
  return position;
};
var adjustNodePathForNodeMove = function adjustNodePathForNodeMove(path, op) {
  if (samePath(op.path, op.newPath)) return path;
  var adjustedPath = path;
  op = moveNodeOpWithConsistentTargetPath(op);
  var actualNewPath = op.newPath;
  if (canAffectPath(op.path, op.newPath, false)) {
    actualNewPath = adjustPath(op.newPath, -1, op.path.size - 1);
  }

  // If the move operation moved our node (or an ancestor of our
  // node), we modify the path to point at the new path, and don't
  // allow newPath to affect our path.
  var nodeMoved = isParentPath(op.path, path) || samePath(op.path, path);
  if (nodeMoved) {
    return actualNewPath.concat(path.slice(op.path.size));
  }
  if (canAffectPath(op.path, adjustedPath, false)) {
    adjustedPath = adjustPath(adjustedPath, -1, op.path.size - 1);
  }
  if (canAffectPath(actualNewPath, adjustedPath, true)) {
    adjustedPath = adjustPath(adjustedPath, 1, op.newPath.size - 1);
  }
  return adjustedPath;
};
var adjustPositionForNodeMove = function adjustPositionForNodeMove(path, op) {
  var affectsEqualPaths = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (samePath(op.path, op.newPath)) return path;
  var adjustedPath = path;
  op = moveNodeOpWithConsistentTargetPath(op);
  var actualNewPath = op.newPath;
  if (canAffectPath(op.path, op.newPath, false)) {
    actualNewPath = adjustPath(op.newPath, -1, op.path.size - 1);
  }

  // If the move operation moved our node (or an ancestor of our
  // node), we modify the path to point at the new path, and don't
  // allow newPath to affect our path.
  var nodeMoved = isParentPath(op.path, path);
  if (nodeMoved) {
    return actualNewPath.concat(path.slice(op.path.size));
  }
  if (canAffectPath(op.path, adjustedPath, false)) {
    adjustedPath = adjustPath(adjustedPath, -1, op.path.size - 1);
  }
  if (canAffectPath(actualNewPath, adjustedPath, affectsEqualPaths)) {
    adjustedPath = adjustPath(adjustedPath, 1, op.newPath.size - 1);
  }
  return adjustedPath;
};
var adjustPathForNodeMerge = function adjustPathForNodeMerge(path, op) {
  var affectsEqualPaths = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var parentLength = op.path.size;
  var adjustedPath = path;
  if (canAffectPath(op.path, path, affectsEqualPaths)) {
    adjustedPath = adjustPath(adjustedPath, -1, parentLength - 1);
  }
  if (isParentPath(op.path, path)) {
    // We're merging a direct parent, so we need to adjust for the new
    // nodes we're adding
    adjustedPath = adjustPath(adjustedPath, op.position, parentLength);
  }
  return adjustedPath;
};
var adjustPositionForNodeMerge = function adjustPositionForNodeMerge(path, position, op) {
  if (samePath(path, op.path)) {
    return position + op.position;
  }
  return position;
};
var adjustPathForNodeInsert = function adjustPathForNodeInsert(path, op, affectsEqualPaths) {
  if (canAffectPath(op.path, path, affectsEqualPaths)) {
    return adjustPath(path, 1, op.path.size - 1);
  }
  return path;
};
var adjustPathForNodeRemove = function adjustPathForNodeRemove(path, op, affectsEqualPaths) {
  if (canAffectPath(op.path, path, affectsEqualPaths)) {
    return adjustPath(path, -1, op.path.size - 1);
  }
  return path;
};

/**
 * Applies `op` to `value`, returning the new `value`.
 *
 * If operations have been transformed, you should always use this
 * function instead of Slate's built-in `editor.applyOperation`,
 * because transformation can get operations into a state that Slate
 * can't handle. If you must use `applyOperation`, you will need to
 * call `fixupOperation` first.
 */
var applyOpToValue = function applyOpToValue(value, op) {
  if (!slate.Value.isValue(value)) {
    value = slate.Value.fromJSON(value);
  }
  return fixupOperation(value, normalizeComponent(op)).apply(value);
};
var crypto = require("crypto");
var sha256 = function sha256(input) {
  return crypto.createHash("sha256").update(JSON.stringify(input)).digest("hex");
};

// Hash document values as we print them, so we can compare them and
// trace our way through the transformation process. This is useful
// for seeing when our transformations diverge.
var valueHash = function valueHash(value) {
  return sha256(value);
};
var valueString = function valueString(value) {
  return "".concat(valueHash(value), " ").concat(JSON.stringify(value));
};

// Try to calculate a hash of the value's schema, so we can assume
// that two values with the same identifier will normalize the same
// document in the same way. We currently can't get all the
// information we need to guarantee it, but this is close enough for now.
var schemaIdentifier = function schemaIdentifier(value) {
  return value.schema ? sha256("".concat(JSON.stringify(value.schema), " ").concat(JSON.stringify(value.schema.stack))) : null;
};
var updateRemovedNodeWithOperation = function updateRemovedNodeWithOperation(removeOp, otherOp) {
  if (!removeOp.node) return;
  if (!removeOp.value) return removeOp.node;
  var updatedValue = applyOpToValue(removeOp.value, otherOp);
  return updatedValue.document.assertNode(removeOp.path);
};
var fixupRemoveNodeOp = function fixupRemoveNodeOp(removeOp, value) {
  return removeOp.set("node", value.document.assertNode(removeOp.path));
};
var comparePaths = function comparePaths(path1, path2) {
  var minSize = Math.min(path1.size, path2.size);
  for (var i = 0; i < minSize; i++) {
    if (path1.get(i) < path2.get(i)) return -1;
    if (path1.get(i) > path2.get(i)) return 1;
  }
  return 0;
};
var merge = function merge(object, newData) {
  if (object.merge) {
    return object.merge(newData);
  } else {
    return Object.assign({}, object, newData);
  }
};
var set = function set(object, key, value) {
  if (object.set) {
    return object.set(key, value);
  } else {
    return Object.assign({}, object, _defineProperty({}, key, value));
  }
};
var isEmpty = function isEmpty(object) {
  for (var _key in object) {
    return false;
  }
  return true;
};

/**
 * Same as `record.setIn(keypath, newValue)`, except when newValue
 * is falsy or an empty object, deletes the object at `keypath` instead.
 */
var updateOrRemove = function updateOrRemove(record, keypath, newValue) {
  if (!newValue || isEmpty(newValue)) {
    return record.deleteIn(keypath);
  } else {
    return record.setIn(keypath, newValue);
  }
};

/**
 * Deletes all keys in `object` with undefined values, making things cleaner.
 */
var removeUndefined = function removeUndefined(object) {
  Object.keys(object).forEach(function (key) {
    if (object[key] === undefined) {
      delete object[key];
    }
  });
  return object;
};

/**
 *  Selections are Ranges with some extra attributes. Most of our
 * transformations are done on Ranges. But when we start with a
 * Selection, we don't want to lose the attributes that were
 * originally set. This function adds them back to the Range, and
 * return a Selection with the merged details.
 */
var copySelectionAttributes = function copySelectionAttributes(range, selection) {
  if (selection.isFocused !== undefined) {
    if (slate.Range.isRange(range)) {
      range = range.set("isFocused", selection.isFocused);
    } else {
      range.isFocused = selection.isFocused;
    }
  }
  return merge(selection, range);
};

// Find a valid text node to move the cursor into, either
// the one preceding or following the removed node.
var fixupCursorPosition = function fixupCursorPosition(cursor, cursorDetails, value) {
  if (!cursorDetails.removed) return cursor;
  var document = value.document;
  delete cursorDetails.removed;
  var texts = document.getTexts();
  if (texts.size === 0) {
    console.warn("Couldn't find a valid text node in document");
    return cursor.unset();
  }
  var previousTexts = texts.takeUntil(function (text) {
    var result = comparePaths(document.getPath(text.key), cursor.path);
    return result !== -1;
  });
  if (previousTexts.size > 0) {
    var previousText = previousTexts.last();
    return merge(cursor, {
      path: document.getPath(previousText.key),
      offset: previousText.text.length
    });
  } else {
    var nextText = texts.first();
    return merge(cursor, {
      path: document.getPath(nextText.key),
      offset: 0
    });
  }
};
var changeRange = function changeRange(range, data, changePoint) {
  var anchor = range.anchor,
    focus = range.focus;
  var anchorDetails = {
    removed: data.anchorRemoved
  };
  var focusDetails = {
    removed: data.focusRemoved
  };
  var newRange = {};

  // We may be modifying paths, so we must set key to null. That will
  // trigger Slate to regenerate it from path.
  if (anchor && anchor.path) {
    anchor = set(anchor, "key", null);
    newRange.anchor = changePoint(slate.Point.create(anchor), anchorDetails);
  }
  if (focus && focus.path) {
    focus = set(focus, "key", null);
    newRange.focus = changePoint(slate.Point.create(focus), focusDetails);
  }
  data.anchorRemoved = anchorDetails.removed;
  data.focusRemoved = focusDetails.removed;
  removeUndefined(data);
  return merge(range, newRange);
};
var changeSelection = function changeSelection(selection, data, changePoint) {
  var newSelection = changeRange(selection, data, changePoint);
  return copySelectionAttributes(newSelection, selection);
};
var fixupOpRange = function fixupOpRange(rangeOp, key, value) {
  var extraData = rangeOp.data.get(key) || {};
  var fixedRange = changeRange(rangeOp.get(key), extraData, function (cursor, cursorDetails) {
    return fixupCursorPosition(cursor, cursorDetails, value);
  });
  var tOp = rangeOp.set(key, fixedRange);
  return updateOrRemove(tOp, ["data", key], extraData);
};
var fixupOpSelection = function fixupOpSelection(op, key, value) {
  var selection = op.get(key);
  var tOp = fixupOpRange(op, key, value);
  tOp = tOp.set(key, copySelectionAttributes(tOp.get(key), selection));
  return tOp;
};
var fixupSetSelectionOp = function fixupSetSelectionOp(op, value) {
  var tOp = op;
  tOp = fixupOpSelection(tOp, "properties", value);
  tOp = fixupOpSelection(tOp, "newProperties", value);
  return tOp;
};
var fixupSetAnnotationOp = function fixupSetAnnotationOp(op, value) {
  var tOp = op;
  tOp = fixupOpRange(tOp, "properties", value);
  tOp = fixupOpRange(tOp, "newProperties", value);
  return tOp;
};
var fixupAnnotationOp = function fixupAnnotationOp(op, value) {
  return fixupOpRange(op, "annotation", value);
};
var fixupOperation = function fixupOperation(value, op) {
  var fixedOp = op;
  if (op.type === "set_selection") {
    fixedOp = fixupSetSelectionOp(op, value);
  } else if (op.type === "remove_node") {
    fixedOp = fixupRemoveNodeOp(op, value);
  } else if (op.annotation) {
    fixedOp = fixupAnnotationOp(op, value);
  } else if (op.type === "set_annotation") {
    fixedOp = fixupSetAnnotationOp(op, value);
  }
  return fixedOp;
};
var fixupOperations = function fixupOperations(value, ops) {
  return ops.map(function (op, index) {
    var fixedOp = fixupOperation(value, op);
    if (index !== ops.length - 1) {
      value = applyOpToValue(value, fixedOp);
    }
    return fixedOp;
  });
};
var normalizeComponent = function normalizeComponent(op) {
  return slate.Operation.isOperation(op) ? op : slate.Operation.create(op);
};
var normalizeOp = function normalizeOp(ops) {
  return ops.map(function (op) {
    return normalizeComponent(op);
  });
};
var operationHistory = function operationHistory(snapshot, leftOps, rightOps, tLeftOps, tRightOps) {
  var string = "  start: ".concat(JSON.stringify(snapshot), "\n  left ops: ").concat(JSON.stringify(normalizeOp(leftOps).map(function (op) {
    return op["delete"]("value");
  })), "\n  right ops: ").concat(JSON.stringify(normalizeOp(rightOps).map(function (op) {
    return op["delete"]("value");
  })));
  if (tLeftOps) {
    string += "\n  transformed left ops: ".concat(JSON.stringify(tLeftOps.map(function (op) {
      return op["delete"]("value");
    })));
  }
  if (tRightOps) {
    string += "\n  transformed right ops: ".concat(JSON.stringify(tRightOps.map(function (op) {
      return op["delete"]("value");
    })));
  }
  return string;
};

var transformCursor = function transformCursor(cursor, cursorDetails, ops, _isOwnOp) {
  // isOwnOp should return the final editing position of op, instead
  // of transforming cursor -- but I don't need that.
  ops = normalizeOp(ops);
  return ops.reduce(function (cursor, op) {
    switch (op.type) {
      case "insert_text":
        {
          if (cursorDetails.removed) return cursor;
          if (!samePath(cursor.path, op.path)) return cursor;
          if (op.offset > cursor.offset) return cursor;
          return merge(cursor, {
            offset: cursor.offset + op.text.length
          });
        }
      case "remove_text":
        {
          if (cursorDetails.removed) return cursor;
          if (!samePath(cursor.path, op.path)) return cursor;
          var deleteBounds = textOpBounds(op);
          if (deleteBounds.start >= cursor.offset) return cursor;
          if (deleteBounds.end <= cursor.offset) {
            return merge(cursor, {
              offset: cursor.offset - op.text.length
            });
          }
          return merge(cursor, {
            offset: deleteBounds.start
          });
        }
      case "split_node":
        {
          if (cursorDetails.removed) {
            return merge(cursor, {
              path: adjustPathForNodeSplit(cursor.path, -1, op, false)
            });
          } else {
            return merge(cursor, {
              path: adjustPathForNodeSplit(cursor.path, cursor.offset, op, true),
              offset: adjustPositionForNodeSplit(cursor.path, cursor.offset, op, true)
            });
          }
        }
      case "merge_node":
        {
          if (cursorDetails.removed) {
            return merge(cursor, {
              path: adjustPathForNodeMerge(cursor.path, op, false)
            });
          } else {
            return merge(cursor, {
              path: adjustPathForNodeMerge(cursor.path, op),
              offset: adjustPositionForNodeMerge(cursor.path, cursor.offset, op)
            });
          }
        }
      case "insert_node":
        {
          return merge(cursor, {
            path: adjustPathForNodeInsert(cursor.path, op, true)
          });
        }
      case "remove_node":
        {
          if (pathWasRemoved(cursor.path, op.path)) {
            // Temporarily put the cursor in the node that was removed,
            // so we can keep track of where it was and transform that
            // position. When we fix things up with an actual value, we
            // can compare paths to put it in the nearest text node.
            var tCursor = merge(cursor, {
              path: op.path,
              offset: 0
            });
            cursorDetails.removed = true;
            return tCursor;
          }
          return merge(cursor, {
            path: adjustPathForNodeRemove(cursor.path, op, false)
          });
        }
      case "move_node":
        {
          if (cursorDetails.removed) {
            return merge(cursor, {
              path: adjustPositionForNodeMove(cursor.path, op)
            });
          } else {
            return merge(cursor, {
              path: adjustNodePathForNodeMove(cursor.path, op)
            });
          }
        }
      case "set_node":
      case "add_mark":
      case "remove_mark":
      case "set_mark":
      case "add_annotation":
      case "remove_annotation":
      case "set_annotation":
      case "set_selection":
      case "set_value":
        {
          return cursor;
        }
    }
    console.warn("couldn't find a cursor transform for " + op.type);
    return cursor;
  }, cursor);
};

/**
 * Transforms `range`'s anchor point and focus point against a set
 * of ops. `data` contains information about whether an endpoint is
 * added or removed, and is modified in-place. For example, if `ops`
 * deletes a node containing the anchor point, this data object will
 * include `{ anchorRemoved: true }`. This allows us to fix up the
 * cursor position once we're given a value and can find a new text
 * node to move it to. (Operations don't carry around the document, so
 * we don't know which paths refer to actual nodes).
 */
function transformRange(range, data, ops) {
  return changeRange(range, data, function (cursor, cursorDetails) {
    return transformCursor(cursor, cursorDetails, ops);
  });
}

/**
 * Transforms the range referred to by `rangeOp[key]` against `op`,
 * returning a new operation with the transformed selection. If an
 * endpoint of the range was removed, `op.data[key]` will indicate it
 * with a flag: { [key]: { anchorRemoved: true } }
 */
function transformOpRange(rangeOp, key, op) {
  var extraData = rangeOp.data.get(key) || {};
  var tOp = rangeOp.set(key, transformRange(rangeOp.get(key), extraData, [op]));
  return updateOrRemove(tOp, ["data", key], extraData);
}

/**
 * Same as transformOpRange, but includes Selection-specific keys like
 * `isFocused`.
 */
function transformOpSelection(selectionOp, key, op) {
  var tOp = transformOpRange(selectionOp, key, op);
  tOp = tOp.set(key, copySelectionAttributes(tOp.get(key), selectionOp.get(key)));
  return tOp;
}

var debug = Debug("ot-slate:validate");
var validateComponent = function validateComponent(op) {
  if (!op.value) {
    console.warn("Can't validate an op without a value: ", op);
  }
  if (debug.enabled) {
    debug("Validating ".concat(JSON.stringify(op)));
  }
  var value = op.value;
  switch (op.type) {
    case "insert_text":
      {
        var targetNode = value.document.assertNode(op.path);
        if (targetNode.object !== "text") {
          throw new Error("insert_text can't insert text into a non-text node");
        }
        var textLength = targetNode.text.length;
        if (op.offset > textLength) {
          throw new Error("insert_text is trying to insert text at offset ".concat(op.offset, ", but the node is only ").concat(textLength, " characters long"));
        }
        break;
      }
    case "remove_text":
      {
        var _targetNode = value.document.assertNode(op.path);
        if (_targetNode.object !== "text") {
          throw new Error("remove_text can't remove text from a non-text node");
        }
        var charactersToDelete = _targetNode.text.slice(op.offset, op.offset + op.text.length);
        if (charactersToDelete !== op.text) {
          throw new Error("remove_text is trying to remove \"".concat(op.text, "\", but the text at ").concat(op.offset, " is \"").concat(charactersToDelete, "\""));
        }
        break;
      }
    case "split_node":
      {
        var _targetNode2 = value.document.assertNode(op.path);
        var childCount = _targetNode2.object === "block" ? _targetNode2.nodes.size : _targetNode2.text.length;
        if (op.position > childCount) {
          throw new Error("split_node has position ".concat(op.position, ", but the node at path ").concat(op.path, " only has ").concat(childCount, " children"));
        }
        break;
      }
    case "merge_node":
      {
        var sourceNode = value.document.assertNode(op.path);
        if (op.path[op.path.length - 1] === 0) {
          throw new Error("merge_node cannot operate on a first child node: ".concat(op.path));
        }
        var targetPath = adjustPath(op.path, -1, op.path.length - 1);
        var _targetNode3 = value.document.assertNode(targetPath);
        if (_targetNode3.object !== sourceNode.object) {
          throw new Error("merge_node cannot merge nodes of two different types. Source: ".concat(sourceNode.object, ", target: ").concat(_targetNode3.object));
        }
        var _childCount = _targetNode3.object === "block" ? _targetNode3.nodes.size : _targetNode3.text.length;
        if (_childCount !== op.position) {
          throw new Error("merge_node has position ".concat(op.position, ", but the node at path ").concat(targetPath, " has ").concat(_childCount, " children"));
        }
        break;
      }
    case "move_node":
      {
        value.document.assertNode(op.path);
        var consistentOp = moveNodeOpWithConsistentTargetPath(op);
        var parentPathOfTarget = op.newPath.slice(0, -1);
        value.document.assertNode(parentPathOfTarget);
        var parentOfTarget = value.document.assertNode(parentPathOfTarget);
        var lastPathComponent = consistentOp.newPath[consistentOp.newPath.length - 1];
        var _childCount2 = parentOfTarget.nodes.size;
        if (lastPathComponent > _childCount2) {
          throw new Error("move_node to position ".concat(op.newPath, " is not valid. ").concat(parentPathOfTarget, " only has ").concat(_childCount2, " children."));
        }
        break;
      }
    case "insert_node":
      {
        // Very similar to the 2nd half of the move_node check.
        var _parentPathOfTarget = op.path.slice(0, -1);
        value.document.assertNode(_parentPathOfTarget);
        var _parentOfTarget = value.document.assertNode(_parentPathOfTarget);
        var _lastPathComponent = op.path[op.path.length - 1];
        var _childCount3 = _parentOfTarget.nodes.length;
        if (_lastPathComponent > _childCount3) {
          throw new Error("insert_node at position ".concat(op.path, " is not valid. ").concat(_parentPathOfTarget, " only has ").concat(_childCount3, " children."));
        }
        break;
      }
    case "remove_node":
      {
        value.document.assertNode(op.path);
        break;
      }
    case "set_selection":
      {
        var properties = op.properties,
          selection = op.selection;
        var anchorNode = properties.anchorPath ? value.document.assertNode(properties.anchorPath) : value.document.getDescendant(selection.anchorKey);
        var focusNode = properties.focusPath ? value.document.assertNode(properties.focusPath) : value.document.getDescendant(selection.focusKey);
        if (properties.anchorOffset < 0) {
          throw new Error("set_selection is trying to move anchorOffset to invalid offset ".concat(properties.anchorOffset));
        }
        if (properties.focusOffset < 0) {
          throw new Error("set_selection is trying to move focusOffset to invalid offset ".concat(properties.anchorOffset));
        }
        var anchorLength = anchorNode.text.length;
        if (properties.anchorOffset > anchorLength) {
          throw new Error("set_selection is trying to move anchorOffset to ".concat(properties.anchorOffset, ", but ").concat(properties.anchorPath, " only has ").concat(anchorLength, " characters"));
        }
        var focusLength = focusNode.text.length;
        if (properties.focusOffset > focusLength) {
          throw new Error("set_selection is trying to move focusOffset to ".concat(properties.focusOffset, ", but ").concat(properties.focusPath, " only has ").concat(focusLength, " characters"));
        }
        break;
      }
  }
};

var debug$1 = Debug("ot-slate:transform");
var transforms = {};
var transformKey = function transformKey(type1, type2) {
  return "".concat(type1, "-").concat(type2);
};
var defineTransform = function defineTransform(type1, type2, transform) {
  if (transforms[transformKey(type1, type2)]) {
    console.warn("Already defined a transform for ".concat(type1, ", ").concat(type2));
  }
  transforms[transformKey(type1, type2)] = transform;
};
var transform = function transform(op1, op2, side) {
  var transformFunction = transforms[transformKey(op1.type, op2.type)];
  if (transformFunction) {
    if (debug$1.enabled) {
      debug$1("transforming (".concat(side, ") ").concat(JSON.stringify(op1)));
      debug$1("  against ".concat(JSON.stringify(op2)));
    }
    var tOp = transformFunction(op1, op2, side);
    if (debug$1.enabled) {
      debug$1("  became  ".concat(JSON.stringify(tOp)));
    }
    return tOp;
  } else {
    console.warn("Unhandled transform: \"".concat(op1.type, "\", \"").concat(op2.type, "\""));
    return op1;
  }
};

defineTransform("insert_text", "insert_text", function (op1, op2, side) {
  if (!samePath(op1.path, op2.path)) return op1;
  if (op1.offset < op2.offset || op1.offset === op2.offset && side === "left") return op1;
  return op1.set("offset", op1.offset + op2.text.length);
});
defineTransform("insert_text", "remove_text", function (op1, op2, side) {
  if (!samePath(op1.path, op2.path)) return op1;
  var bounds1 = textOpBounds(op1);
  var bounds2 = textOpBounds(op2);
  if (bounds1.start < bounds2.start) return op1;
  if (bounds1.start < bounds2.end) return op1.set("offset", bounds2.start);
  return op1.set("offset", bounds1.start - op2.text.length);
});
defineTransform("insert_text", "split_node", function (op1, op2, side) {
  var tOp = op1;
  tOp = tOp.set("path", adjustPathForNodeSplit(op1.path, op1.offset, op2, side === "left"));
  return tOp.set("offset", adjustPositionForNodeSplit(op1.path, op1.offset, op2, side === "left"));
});
defineTransform("insert_text", "merge_node", function (op1, op2, side) {
  return op1.set("path", adjustPathForNodeMerge(op1.path, op2)).set("offset", adjustPositionForNodeMerge(op1.path, op1.offset, op2));
});
defineTransform("insert_text", "move_node", function (op1, op2, side) {
  return op1.set("path", adjustNodePathForNodeMove(op1.path, op2));
});
defineTransform("insert_text", "insert_node", function (op1, op2, side) {
  return op1.set("path", adjustPathForNodeInsert(op1.path, op2, true));
});
defineTransform("insert_text", "remove_node", function (op1, op2, side) {
  if (pathWasRemoved(op1.path, op2.path)) return;
  return op1.set("path", adjustPathForNodeRemove(op1.path, op2, false));
});
defineTransform("insert_text", "set_node", function (op1, op2, side) {
  return op1;
});
defineTransform("insert_text", "add_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("insert_text", "remove_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("insert_text", "set_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("insert_text", "add_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("insert_text", "remove_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("insert_text", "set_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("insert_text", "set_selection", function (op1, op2, side) {
  return op1;
});

defineTransform("remove_text", "insert_text", function (op1, op2, side) {
  if (!samePath(op1.path, op2.path)) return op1;
  var bounds1 = textOpBounds(op1);
  var bounds2 = textOpBounds(op2);
  if (bounds1.end < bounds2.start) return op1;
  var ops = [];
  var slicedText = op1.text;
  if (bounds1.start < bounds2.start) {
    ops = ops.concat([op1.set("text", op1.text.slice(0, bounds2.start - bounds1.start))]);
    slicedText = op1.text.slice(bounds2.start - bounds1.start);
  }
  ops = ops.concat([op1.merge({
    offset: op1.offset + op2.text.length,
    text: slicedText
  })]);
  return ops;
});
defineTransform("remove_text", "remove_text", function (op1, op2, side) {
  if (!samePath(op1.path, op2.path)) return op1;
  var bounds1 = textOpBounds(op1);
  var bounds2 = textOpBounds(op2);
  if (bounds1.end < bounds2.start) return op1;
  if (bounds1.start >= bounds2.end) return op1.set("offset", op1.offset - op2.text.length);

  // Handle overlapping ranges
  var tOp = op1.set("text", "");

  // Slice text off the beginning that wasn't deleted by bounds2
  if (bounds1.start < bounds2.start) {
    tOp = tOp.set("text", op1.text.slice(0, bounds2.start - bounds1.start));
  }

  // Slice text off the end that wasn't deleted by bounds2
  if (bounds1.end > bounds2.end) {
    tOp = tOp.set("text", tOp.text + op1.text.slice(bounds2.end - bounds1.start));
  }

  // Adjust the offset
  if (bounds1.start > bounds2.start) {
    tOp = tOp.set("offset", bounds2.start);
  }
  return tOp;
});
defineTransform("remove_text", "split_node", function (op1, op2, side) {
  var tOp = op1;
  if (samePath(op1.path, op2.path)) {
    var bounds1 = textOpBounds(op1);

    // Our delete spans the split, so we need to transform it into
    // two operations, one on either side of the split.
    if ((bounds1.start < op2.position || bounds1.start === op2.position && side === "right") && bounds1.end > op2.position) {
      var leftText = op1.text.slice(0, op2.position - bounds1.start);
      var rightText = op1.text.slice(op2.position - bounds1.start);
      var leftOp = op1.set("text", leftText);
      var rightOp = op1.set("path", adjustPath(op1.path, 1, op1.path.size - 1)).set("offset", 0).set("text", rightText);
      return [leftOp, rightOp];
    }
  }
  tOp = tOp.set("path", adjustPathForNodeSplit(op1.path, op1.offset, op2, side));
  return tOp.set("offset", adjustPositionForNodeSplit(op1.path, op1.offset, op2, side === "left"));
});
defineTransform("remove_text", "merge_node", function (op1, op2, side) {
  return op1.set("path", adjustPathForNodeMerge(op1.path, op2)).set("offset", adjustPositionForNodeMerge(op1.path, op1.offset, op2));
});
defineTransform("remove_text", "move_node", function (op1, op2, side) {
  return op1.set("path", adjustNodePathForNodeMove(op1.path, op2));
});
defineTransform("remove_text", "insert_node", function (op1, op2, side) {
  return op1.set("path", adjustPathForNodeInsert(op1.path, op2, true));
});
defineTransform("remove_text", "remove_node", function (op1, op2, side) {
  if (pathWasRemoved(op1.path, op2.path)) return;
  return op1.set("path", adjustPathForNodeRemove(op1.path, op2, true));
});
defineTransform("remove_text", "set_node", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_text", "add_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_text", "remove_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_text", "set_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_text", "add_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_text", "remove_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_text", "set_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_text", "set_selection", function (op1, op2, side) {
  return op1;
});

defineTransform("insert_node", "insert_text", function (op1, op2, side) {
  return op1;
});
defineTransform("insert_node", "remove_text", function (op1, op2, side) {
  return op1;
});
defineTransform("insert_node", "split_node", function (op1, op2, side) {
  // Insert has precedence over split
  if (samePath(op1.path.slice(0, -1), op2.path) && op2.position === op1.path.get(op1.path.size - 1)) {
    return op1;
  }
  return op1.set("path", adjustPathForNodeSplit(op1.path, -1, op2, side === "left"));
});
defineTransform("insert_node", "merge_node", function (op1, op2, side) {
  return op1.set("path", adjustPathForNodeMerge(op1.path, op2, false));
});
defineTransform("insert_node", "move_node", function (op1, op2, side) {
  return op1.set("path", adjustPositionForNodeMove(op1.path, op2, side === "right"));
});
defineTransform("insert_node", "insert_node", function (op1, op2, side) {
  return op1.set("path", adjustPathForNodeInsert(op1.path, op2, side === "right"));
});
defineTransform("insert_node", "remove_node", function (op1, op2, side) {
  var tOp = op1;
  if (isParentPath(op2.path, op1.path)) return;
  tOp = tOp.set("path", adjustPathForNodeRemove(tOp.path, op2));
  return tOp;
});
defineTransform("insert_node", "set_node", function (op1, op2, side) {
  return op1;
});
defineTransform("insert_node", "add_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("insert_node", "remove_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("insert_node", "set_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("insert_node", "add_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("insert_node", "remove_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("insert_node", "set_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("insert_node", "set_selection", function (op1, op2, side) {
  return op1;
});

defineTransform("merge_node", "insert_text", function (op1, op2, side) {
  var targetNodePath = adjustPath(op1.path, -1, op1.path.size - 1);
  if (samePath(targetNodePath, op2.path)) {
    return op1.set("position", op1.position + op2.text.length);
  }
  return op1;
});
defineTransform("merge_node", "remove_text", function (op1, op2, side) {
  var targetNodePath = adjustPath(op1.path, -1, op1.path.size - 1);
  if (samePath(targetNodePath, op2.path)) {
    return op1.set("position", op1.position - op2.text.length);
  }
  return op1;
});
defineTransform("merge_node", "split_node", function (op1, op2, side) {
  var tOp = op1;

  // Position is -1, because a split on our node should never affect
  // our merge. We always want to lose the tiebreaker. We merge
  // whatever nodes we have left after the split.
  tOp = tOp.set("path", adjustPathForNodeSplit(op1.path, -1, op2, true));
  var targetPath = adjustPath(op1.path, -1, op1.path.size - 1);
  if (samePath(targetPath, op2.path)) {
    // If we're splitting the node we're merging into, adjust our position to
    // the number of nodes in the newly split node.
    tOp = tOp.set("position", tOp.position - op2.position);
  }
  if (samePath(targetPath, op2.path.slice(0, -1))) {
    // If we're splitting a child of the node we're merging into, we
    // have to adjust our position to account for the added node.
    tOp = tOp.set("position", tOp.position + 1);
  }
  if (tOp.path.get(tOp.path.size - 1) === 0) {
    // We have no node to merge into, so we need to move the node into
    // the other tree.
    var previousNodePath = adjustPath(op1.path, -1, op1.path.size - 1);
    var moveOperation = slate.Operation.create({
      type: "move_node",
      path: previousNodePath,
      newPath: tOp.path
    });
    return [moveOperation, tOp.set("path", adjustNodePathForNodeMove(tOp.path, moveOperation))];
  }
  return tOp;
});
defineTransform("merge_node", "merge_node", function (op1, op2, side) {
  if (samePath(op1.path, op2.path)) return;
  var tOp = op1;
  var parentLength = op2.path.size;
  tOp = tOp.set("path", adjustPathForNodeMerge(op1.path, op2));
  if (samePath(op1.path, adjustPath(op2.path, 1, parentLength - 1))) {
    // We merged the sibling before ours, so we need to adjust for the new nodes.
    tOp = tOp.set("position", tOp.position + op2.position);
  }
  if (samePath(op1.path, adjustPath(op2.path.slice(0, -1), 1, parentLength - 2))) {
    // We merged a child of the node we're merging into, so there's
    // one fewer node over there than there used to be.
    tOp = tOp.set("position", tOp.position - 1);
  }
  return tOp;
});
defineTransform("merge_node", "move_node", function (op1, op2, side) {
  // if it's a no-op move, our merge doesn't need to change.
  if (samePath(op2.path, op2.newPath)) return op1;
  var tOp = op1;
  tOp = tOp.set("path", adjustNodePathForNodeMove(op1.path, op2));
  var previousNodePath = adjustPath(op1.path, -1, op1.path.size - 1);
  if (samePath(op1.path, op2.path) || samePath(op1.path, op2.newPath)) {
    // Move should dominate merge, so we must ignore this conflicting
    // merge. On the other side the node will be split, then moved.
    return;
  }
  if (samePath(previousNodePath, op2.path)) {
    // If the node we're merging into has been moved, we need to move alongside it, so the merge still has the same effect.

    var newPath = adjustPathForNodeMerge(op2.newPath, op1);
    var moveOperation = slate.Operation.create({
      type: "move_node",
      path: tOp.path,
      newPath: adjustPath(newPath, 1, newPath.size - 1)
    });
    tOp = tOp.set("path", adjustNodePathForNodeMove(tOp.path, moveOperation));
    return [moveOperation, tOp];
  }
  if (samePath(op1.path, op2.newPath)) {
    // if a node has been inserted between our node and the node we're
    // merging into, move it so it won't merge into the newly inserted
    // node.
    var _moveOperation = slate.Operation.create({
      type: "move_node",
      path: tOp.path,
      newPath: op1.path
    });
    tOp = tOp.set("path", _moveOperation.newPath);
    return [_moveOperation, tOp];
  }

  // If we moved one of our previous siblings' child nodes, we need to
  // adjust the position for the now missing child.
  if (isParentPath(previousNodePath, op2.path) && op2.path.size === op1.path.size + 1) {
    tOp = tOp.set("position", op1.position - 1);
  }
  if (isParentPath(previousNodePath, op2.newPath) && op2.newPath.size === op1.path.size + 1) {
    tOp = tOp.set("position", op1.position + 1);
  }
  return tOp;
});
defineTransform("merge_node", "insert_node", function (op1, op2, side) {
  var tOp = op1;
  tOp = tOp.set("path", adjustPathForNodeInsert(tOp.path, op2, false));

  // If we inserted a node between our node and the one we merged
  // into, move our node before the newly inserted node so we can
  // perform our original merge.
  if (samePath(op1.path, op2.path)) {
    var moveNodeOperation = slate.Operation.create({
      type: "move_node",
      path: adjustPath(op1.path, 1, op1.path.size - 1),
      newPath: tOp.path
    });
    return [moveNodeOperation, tOp];
  }
  var targetNodePath = adjustPath(op1.path, -1, op1.path.size - 1);
  if (op2.path.size === targetNodePath.size + 1 && isParentPath(targetNodePath, op2.path)) {
    // We added a child to the node we're merging into, so we need to
    // adjust the position to match.
    tOp = tOp.set("position", tOp.position + 1);
  }
  return tOp;
});
defineTransform("merge_node", "remove_node", function (op1, op2, side) {
  var tOp = op1;
  var targetNodePath = adjustPath(op1.path, -1, op1.path.size - 1);
  if (pathWasRemoved(op1.path, op2.path) || pathWasRemoved(targetNodePath, op2.path)) return;
  if (op2.path.size === targetNodePath.size + 1 && isParentPath(targetNodePath, op2.path)) {
    // We added a child to the node we're merging into, so we need to
    // adjust the position to match.
    tOp = tOp.set("position", tOp.position - 1);
  }
  tOp = tOp.set("path", adjustPathForNodeRemove(op1.path, op2, false));
  return tOp;
});
defineTransform("merge_node", "set_node", function (op1, op2, side) {
  return op1;
});
defineTransform("merge_node", "add_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("merge_node", "remove_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("merge_node", "set_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("merge_node", "add_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("merge_node", "remove_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("merge_node", "set_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("merge_node", "set_selection", function (op1, op2, side) {
  return op1;
});

defineTransform("move_node", "insert_text", function (op1, op2, side) {
  return op1;
});
defineTransform("move_node", "remove_text", function (op1, op2, side) {
  return op1;
});
defineTransform("move_node", "split_node", function (op1, op2, side) {
  if (samePath(op1.path, op1.newPath)) {
    // If the move isn't actually moving anything, it doesn't need
    // to exist.
    return;
  }
  var tOp = op1;
  tOp = moveNodeOpWithConsistentTargetPath(tOp);

  // Just like merge_node, we always want to move the first part of a
  // split. So we pass -1 for position, to lose the tiebreaker.
  tOp = tOp.set("path", adjustPathForNodeSplit(tOp.path, -1, op2, side === "left"));

  // There's an edge case right on the border of the split.
  //
  // Our "consistent node path" treats newPath as if the original node
  // has not been removed yet. But if the split is targeting the
  // original newPath, that will place the "consistent" newPath
  // _after_ the split -- even though it should just be swapping nodes
  // right before the split. I can't think of a way to handle this
  // without breaking the case where you insert after the split -- in
  // one case or the other, we'll have to make an adjustment.
  if (isParentPath(op2.path, op1.path) && op2.path.size === op1.newPath.size - 1 && op1.newPath.last() < tOp.newPath.last() && tOp.newPath.last() === op2.position) ; else {
    // We also want to move _to_ the position before a split.
    tOp = tOp.set("newPath", adjustPathForNodeSplit(tOp.newPath, -1, op2, side === "left"));
  }
  tOp = moveNodeOpWithSlateTargetPath(tOp);

  // If we're moving the node we split, we want to move both parts, to
  // mirror the case where we split a moved node.
  if (samePath(op1.path, op2.path)) {
    var moveFirstPartOp = tOp;
    var moveSecondPartOp = tOp.set("path", adjustPath(tOp.path, 1, tOp.path.size - 1));

    // We always want secondPart to lose the tiebreaker, because it's
    // the second part of our split, and we want its position to get
    // pushed over by the first part.
    moveSecondPartOp = transform(moveSecondPartOp, moveFirstPartOp, "right");
    return [moveFirstPartOp, moveSecondPartOp];
  }
  return tOp;
});
defineTransform("move_node", "merge_node", function (op1, op2, side) {
  var tOp = moveNodeOpWithConsistentTargetPath(op1);
  if (samePath(op1.path, op2.path)) {
    // Move dominates merge. If we're moving a node that was merged,
    // split it back out and then move it.
    return [op2.invert(), op1];
  }
  if (samePath(op1.newPath, op2.path)) {
    // Move dominates merge. If we're moving a node in between two
    // merged nodes, split them and then move in between them.
    return [op2.invert(), op1];
  }
  tOp = tOp.set("path", adjustPathForNodeMerge(op1.path, op2));
  // We don't need to affect equal paths, because we're targeting a
  // position, not a node
  tOp = tOp.set("newPath", adjustPathForNodeMerge(op1.newPath, op2, false));
  return moveNodeOpWithSlateTargetPath(tOp);
});
defineTransform("move_node", "move_node", function (op1, op2, side) {
  if (samePath(op2.path, op2.newPath)) {
    // The other move won't actually accomplish anything, so let's
    // shortcut it.
    return op1;
  }
  var tOp = moveNodeOpWithConsistentTargetPath(op1);
  if (samePath(op1.path, op2.path)) {
    if (side === "right" && !samePath(op1.path, op1.newPath)) {
      var cOp2 = moveNodeOpWithConsistentTargetPath(op2);
      tOp = tOp.set("path", adjustPositionForNodeMove(cOp2.newPath, op2, false)).set("newPath", adjustPositionForNodeMove(tOp.newPath, op2, false));
      return moveNodeOpWithSlateTargetPath(tOp);
    } else {
      // If both operations are moving the same node, one of them
      // has to COOL IT
      return;
    }
  }
  if (isParentPath(op2.path, op1.newPath) && isParentPath(op1.path, op2.newPath)) {
    // Each op is moving a node into a child of the other node to be
    // moved. One of them is going to have to lose.
    if (side === "right") {
      return [op2.invert(), op1];
    } else {
      return;
    }
  }
  tOp = tOp.set("path", adjustNodePathForNodeMove(tOp.path, op2));

  // If path and newPath are the same at the beginning, they must end
  // up the same.
  if (samePath(op1.path, op1.newPath)) {
    tOp = tOp.set("newPath", tOp.path);
  } else {
    tOp = tOp.set("newPath", adjustPositionForNodeMove(tOp.newPath, op2, side === "right"));
  }
  return moveNodeOpWithSlateTargetPath(tOp);
});
defineTransform("move_node", "insert_node", function (op1, op2, side) {
  var tOp = moveNodeOpWithConsistentTargetPath(op1);
  tOp = tOp.set("path", adjustPathForNodeInsert(tOp.path, op2, true));

  // If path and newPath are the same at the beginning, they must end
  // up the same.
  if (samePath(op1.path, op1.newPath)) {
    tOp = tOp.set("newPath", tOp.path);
  } else {
    tOp = tOp.set("newPath", adjustPathForNodeInsert(tOp.newPath, op2, side === "right"));
  }
  return moveNodeOpWithSlateTargetPath(tOp);
});
defineTransform("move_node", "remove_node", function (op1, op2, side) {
  var tOp = op1;
  if (pathWasRemoved(op1.path, op2.path)) return;
  if (isParentPath(op2.path, op1.newPath)) {
    var path = adjustPathForNodeRemove(op1.path, op2);
    var removeOp = slate.Operation.create({
      type: "remove_node",
      path: path,
      // Placeholder, because we can't know anything about the
      // node. If it's important, it will get fixed up in a final pass
      // over the Value.
      node: {
        object: "block",
        type: "paragraph",
        nodes: []
      }
    });
    return removeOp;
  }
  tOp = moveNodeOpWithConsistentTargetPath(tOp);
  tOp = tOp.set("path", adjustPathForNodeRemove(tOp.path, op2, true));
  tOp = tOp.set("newPath", adjustPathForNodeRemove(tOp.newPath, op2, false));
  return moveNodeOpWithSlateTargetPath(tOp);
});
defineTransform("move_node", "set_node", function (op1, op2, side) {
  return op1;
});
defineTransform("move_node", "add_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("move_node", "remove_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("move_node", "set_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("move_node", "add_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("move_node", "remove_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("move_node", "set_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("move_node", "set_selection", function (op1, op2, side) {
  return op1;
});

defineTransform("remove_node", "insert_text", function (op1, op2, side) {
  if (pathWasRemoved(op2.path, op1.path)) {
    return op1.set("node", updateRemovedNodeWithOperation(op1, op2));
  }
  return op1;
});
defineTransform("remove_node", "remove_text", function (op1, op2, side) {
  if (pathWasRemoved(op2.path, op1.path)) {
    return op1.set("node", updateRemovedNodeWithOperation(op1, op2));
  }
  return op1;
});
defineTransform("remove_node", "split_node", function (op1, op2, side) {
  var tOp = op1;
  if (isParentPath(op1.path, op2.path)) {
    return op1.set("node", updateRemovedNodeWithOperation(op1, op2));
  }
  if (samePath(op1.path, op2.path)) {
    var removeBeforeSplit = tOp;
    var removeAfterSplit = tOp;
    return [removeBeforeSplit, removeAfterSplit];
  }
  tOp = tOp.set("path", adjustPathForNodeSplit(op1.path, -1, op2, side === "left"));
  return tOp;
});
defineTransform("remove_node", "merge_node", function (op1, op2, side) {
  var tOp = op1;
  if (isParentPath(op1.path, op2.path)) {
    return op1.set("node", updateRemovedNodeWithOperation(op1, op2));
  }

  // If the newly merged node includes part of the node we're
  // removing, we want to split it out before removing so we only
  // remove the part we're expecting to.
  if (samePath(op1.path, op2.path) || samePath(op1.path, adjustPath(op2.path, -1, op2.path.size - 1))) {
    var splitNodeOperation = op2.invert();
    return [splitNodeOperation, tOp];
  }
  tOp = tOp.set("path", adjustPathForNodeMerge(op1.path, op2));
  return tOp;
});
defineTransform("remove_node", "move_node", function (op1, op2, side) {
  var tOp = op1;
  tOp = tOp.set("path", adjustNodePathForNodeMove(op1.path, op2));
  if (pathWasRemoved(op2.path, op1.path) && !samePath(op1.path, op2.path) && !isParentPath(op1.path, op2.newPath)) {
    // If the source was removed, I'm making the call not to add it to
    // the destination. Hopefully that's OK. Otherwise I'll also need
    // to change move_node, remove_node, and reverting the remove
    // would duplicate the moved node.
    //
    // But, if we're moving a node from our subtree to our subtree,
    // it'll get deleted anyway, so we can skip the invert. It might
    // do something weird if you undo the op, though.
    var removeNodeOp = tOp;
    var removeChildOp = tOp.set("path", adjustNodePathForNodeMove(op2.path, op2));
    removeChildOp = removeChildOp.set("path", adjustPathForNodeRemove(removeChildOp.path, removeNodeOp, false));
    return [removeNodeOp, removeChildOp];
  }
  return tOp;
});
defineTransform("remove_node", "insert_node", function (op1, op2, side) {
  if (isParentPath(op1.path, op2.path)) {
    return op1.set("node", updateRemovedNodeWithOperation(op1, op2));
  }
  return op1.set("path", adjustPathForNodeInsert(op1.path, op2, true));
});
defineTransform("remove_node", "remove_node", function (op1, op2, side) {
  var tOp = op1;
  if (isParentPath(op1.path, op2.path)) {
    return op1.set("node", updateRemovedNodeWithOperation(op1, op2));
  } else if (pathWasRemoved(op1.path, op2.path)) {
    return;
  }
  tOp = tOp.set("path", adjustPathForNodeRemove(op1.path, op2, false));
  return tOp;
});
defineTransform("remove_node", "set_node", function (op1, op2, side) {
  if (samePath(op1.path, op2.path) || isParentPath(op1.path, op2.path)) {
    return op1.set("node", updateRemovedNodeWithOperation(op1, op2));
  }
  return op1;
});
defineTransform("remove_node", "add_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_node", "remove_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_node", "set_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_node", "add_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_node", "remove_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_node", "set_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_node", "set_selection", function (op1, op2, side) {
  return op1;
});

defineTransform("split_node", "insert_text", function (op1, op2, side) {
  if (!samePath(op1.path, op2.path)) return op1;
  if (op1.position < op2.offset) return op1;
  if (op1.position === op2.offset && side === "right") return op1;
  return op1.set("position", op1.position + op2.text.length);
});
defineTransform("split_node", "remove_text", function (op1, op2, side) {
  if (!samePath(op1.path, op2.path)) return op1;
  if (op1.position < op2.offset) return op1;
  var bounds2 = textOpBounds(op2);
  if (op1.position >= bounds2.start && op1.position < bounds2.end) {
    return op1.set("position", op2.offset);
  }
  return op1.set("position", op1.position - op2.text.length);
});
defineTransform("split_node", "split_node", function (op1, op2, side) {
  var tOp = op1;
  tOp = tOp.set("path", adjustPathForNodeSplit(op1.path, op1.position, op2, side === "left"));

  // Splitting a child of the node we want to split, might affect
  // our position (imagine we were splitting at node 4, which is now
  // node 5)
  if (isParentPath(op1.path, op2.path) && op2.path.size === op1.path.size + 1) {
    if (op1.position <= op2.path.get(op1.path.size)) return tOp;
    return tOp.set("position", op1.position + 1);
  }

  // Same operation, do nothing
  if (samePath(op1.path, op2.path) && op1.position === op2.position) return;
  return tOp.set("position", adjustPositionForNodeSplit(op1.path, op1.position, op2, side === "left"));
});
defineTransform("split_node", "merge_node", function (op1, op2, side) {
  var tOp = op1;
  var parentLength = op2.path.size;
  tOp = tOp.set("path", adjustPathForNodeMerge(op1.path, op2));
  if (samePath(op1.path, op2.path)) {
    // We merged the node we're trying to split, so we need to adjust
    // for the new nodes.
    tOp = tOp.set("position", tOp.position + op2.position);
  }

  // Merging a child of the node we want to split, might affect
  // our position (imagine we were splitting at node 4, which is now
  // node 3)
  if (isParentPath(op1.path, op2.path) && op2.path.size === op1.path.size + 1) {
    if (op1.position < op2.path.get(op1.path.size)) return tOp;
    return tOp.set("position", op1.position - 1);
  }
  return tOp;
});
defineTransform("split_node", "move_node", function (op1, op2, side) {
  var tOp = op1;
  tOp = tOp.set("path", adjustNodePathForNodeMove(op1.path, op2));

  // If we moved one of our child nodes, we need to adjust the
  // position for the now missing child.
  if (isParentPath(op1.path, op2.path) && op2.path.size === op1.path.size + 1) {
    if (op1.position > op2.path.get(op1.path.size)) {
      tOp = tOp.set("position", op1.position - 1);
    }
  }
  if (isParentPath(op1.path, op2.newPath) && op2.newPath.size === op1.path.size + 1) {
    if (op1.position > op2.newPath.get(op1.path.size)) {
      tOp = tOp.set("position", tOp.position + 1);
    }
  }
  return tOp;
});
defineTransform("split_node", "insert_node", function (op1, op2, side) {
  var tOp = op1;

  // If a node is being inserted as a child, before our split
  // position, our split position has to take that new node into
  // account.
  if (op2.path.size === op1.path.size + 1 && isParentPath(op1.path, op2.path) && op2.path.get(op2.path.size - 1) <= op1.position) {
    return tOp.set("position", tOp.position + 1);
  }
  tOp = tOp.set("path", adjustPathForNodeInsert(tOp.path, op2, true));
  return tOp;
});
defineTransform("split_node", "remove_node", function (op1, op2, path) {
  var tOp = op1;
  if (pathWasRemoved(op1.path, op2.path)) return;
  if (op2.path.size === op1.path.size + 1 && isParentPath(op1.path, op2.path) && op2.path.get(op2.path.size - 1) < op1.position) {
    return tOp.set("position", tOp.position - 1);
  }
  tOp = tOp.set("path", adjustPathForNodeRemove(op1.path, op2, false));
  return tOp;
});
defineTransform("split_node", "set_node", function (op1, op2, side) {
  if (!samePath(op1.path, op2.path)) return op1;
  return op1.set("properties", merge(op1.properties, op2.newProperties));
});
defineTransform("split_node", "add_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("split_node", "remove_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("split_node", "set_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("split_node", "add_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("split_node", "remove_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("split_node", "set_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("split_node", "set_selection", function (op1, op2, side) {
  return op1;
});

defineTransform("set_node", "insert_text", function (op1, op2, side) {
  return op1;
});
defineTransform("set_node", "remove_text", function (op1, op2, side) {
  return op1;
});
defineTransform("set_node", "split_node", function (op1, op2, side) {
  if (samePath(op1.path, op2.path)) {
    return [op1, op1.set("path", adjustPath(op1.path, 1, op1.path.size - 1))];
  }
  return op1.set("path", adjustPathForNodeSplit(op1.path, -1, op2, side === "left"));
});
defineTransform("set_node", "merge_node", function (op1, op2, side) {
  if (samePath(op1.path, op2.path)) return;
  return op1.set("path", adjustPathForNodeMerge(op1.path, op2));
});
defineTransform("set_node", "move_node", function (op1, op2, side) {
  return op1.set("path", adjustNodePathForNodeMove(op1.path, op2));
});
defineTransform("set_node", "insert_node", function (op1, op2, side) {
  return op1.set("path", adjustPathForNodeInsert(op1.path, op2, true));
});
defineTransform("set_node", "remove_node", function (op1, op2, side) {
  if (pathWasRemoved(op1.path, op2.path)) return;
  return op1.set("path", adjustPathForNodeRemove(op1.path, op2));
});
defineTransform("set_node", "set_node", function (op1, op2, side) {
  if (!samePath(op1.path, op2.path)) return op1;
  var newProperties;
  if (side === "left") {
    newProperties = Object.assign({}, op2.newProperties, op1.newProperties);
  } else {
    newProperties = Object.assign({}, op1.newProperties, op2.newProperties);
  }
  return op1.set("newProperties", newProperties);
});
defineTransform("set_node", "add_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("set_node", "remove_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("set_node", "set_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("set_node", "add_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("set_node", "remove_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("set_node", "set_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("set_node", "set_selection", function (op1, op2, side) {
  return op1;
});

defineTransform("add_mark", "insert_text", function (op1, op2, side) {
  return op1;
});
defineTransform("add_mark", "remove_text", function (op1, op2, side) {
  return op1;
});
defineTransform("add_mark", "split_node", function (op1, op2, side) {
  if (samePath(op1.path, op2.path)) {
    return [op1, op1.set("path", adjustPath(op1.path, 1, op1.path.size - 1))];
  }
  return op1.set("path", adjustPathForNodeSplit(op1.path, -1, op2, true));
});
defineTransform("add_mark", "merge_node", function (op1, op2, side) {
  return op1.set("path", adjustPathForNodeMerge(op1.path, op2));
});
defineTransform("add_mark", "move_node", function (op1, op2, side) {
  return op1.set("path", adjustNodePathForNodeMove(op1.path, op2));
});
defineTransform("add_mark", "insert_node", function (op1, op2, side) {
  return op1.set("path", adjustPathForNodeInsert(op1.path, op2, true));
});
defineTransform("add_mark", "remove_node", function (op1, op2, side) {
  if (pathWasRemoved(op1.path, op2.path)) return;
  return op1.set("path", adjustPathForNodeRemove(op1.path, op2, true));
});
defineTransform("add_mark", "set_node", function (op1, op2, side) {
  return op1;
});
defineTransform("add_mark", "add_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("add_mark", "remove_mark", function (op1, op2, side) {
  if (!samePath(op1.path, op2.path)) return op1;
  if (!op1.mark.equals(op2.mark)) return op1;
  return [];
});
defineTransform("add_mark", "set_mark", function (op1, op2, side) {
  if (!samePath(op1.path, op2.path)) return op1;
  if (!equalMarks(op1.mark, op2.properties)) return op1;
  return op1.set("mark", op1.mark.merge(op2.newProperties));
});
defineTransform("add_mark", "add_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("add_mark", "remove_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("add_mark", "set_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("add_mark", "set_selection", function (op1, op2, side) {
  return op1;
});

defineTransform("remove_mark", "insert_text", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_mark", "remove_text", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_mark", "split_node", function (op1, op2, side) {
  if (samePath(op1.path, op2.path)) {
    return [op1, op1.set("path", adjustPath(op1.path, 1, op1.path.size - 1))];
  }
  return op1.set("path", adjustPathForNodeSplit(op1.path, -1, op2, true));
});
defineTransform("remove_mark", "merge_node", function (op1, op2, side) {
  return op1.set("path", adjustPathForNodeMerge(op1.path, op2));
});
defineTransform("remove_mark", "move_node", function (op1, op2, side) {
  return op1.set("path", adjustNodePathForNodeMove(op1.path, op2));
});
defineTransform("remove_mark", "insert_node", function (op1, op2, side) {
  return op1.set("path", adjustPathForNodeInsert(op1.path, op2, true));
});
defineTransform("remove_mark", "remove_node", function (op1, op2, side) {
  if (pathWasRemoved(op1.path, op2.path)) return;
  return op1.set("path", adjustPathForNodeRemove(op1.path, op2, true));
});
defineTransform("remove_mark", "set_node", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_mark", "add_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_mark", "remove_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_mark", "set_mark", function (op1, op2, side) {
  if (!samePath(op1.path, op2.path)) return op1;
  if (!equalMarks(op1.mark, op2.properties)) return op1;

  // It's possible that set_mark set a mark to an already existing
  // mark. For example, it set `type: italic` to `type: bold` on a
  // text node that was already bold. In that case, Slate would merge
  // the marks together, and our delete would delete the merged
  // mark. On the other document, to be consistent, both the old and
  // new marks also have to be gone.
  return [op1, op1.set("mark", op1.mark.merge(op2.newProperties))];
});
defineTransform("remove_mark", "add_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_mark", "remove_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_mark", "set_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_mark", "set_selection", function (op1, op2, side) {
  return op1;
});

function mergeMarkProperties(props1, props2) {
  var props1Wins = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return props1Wins ? Object.assign({}, props1, {
    type: props1.type,
    data: props2.data.merge(props1.data)
  }) : Object.assign({}, props1, {
    type: props2.type,
    data: props1.data.merge(props2.data)
  });
}
defineTransform("set_mark", "insert_text", function (op1, op2, side) {
  return op1;
});
defineTransform("set_mark", "remove_text", function (op1, op2, side) {
  return op1;
});
defineTransform("set_mark", "split_node", function (op1, op2, side) {
  if (samePath(op1.path, op2.path)) {
    return [op1, op1.set("path", adjustPath(op1.path, 1, op1.path.size - 1))];
  }
  return op1.set("path", adjustPathForNodeSplit(op1.path, -1, op2, true));
});
defineTransform("set_mark", "merge_node", function (op1, op2, side) {
  return op1.set("path", adjustPathForNodeMerge(op1.path, op2));
});
defineTransform("set_mark", "move_node", function (op1, op2, side) {
  return op1.set("path", adjustNodePathForNodeMove(op1.path, op2));
});
defineTransform("set_mark", "insert_node", function (op1, op2, side) {
  return op1.set("path", adjustPathForNodeInsert(op1.path, op2, true));
});
defineTransform("set_mark", "remove_node", function (op1, op2, side) {
  if (pathWasRemoved(op1.path, op2.path)) return;
  return op1.set("path", adjustPathForNodeRemove(op1.path, op2, true));
});
defineTransform("set_mark", "set_node", function (op1, op2, side) {
  return op1;
});
defineTransform("set_mark", "add_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("set_mark", "remove_mark", function (op1, op2, side) {
  if (!samePath(op1.path, op2.path)) return op1;
  if (equalMarks(op1.properties, op2.mark)) {
    return op2.set("mark", op2.mark.merge(op1.newProperties));
  }
  if (equalMarks(op1.newProperties, op2.mark)) {
    return op2.set("mark", op2.mark.merge(op1.properties));
  }
  return op1;
});
defineTransform("set_mark", "set_mark", function (op1, op2, side) {
  if (!samePath(op1.path, op2.path)) return op1;
  if (equalMarks(op1.properties, op1.newProperties)) return [];
  if (equalMarks(op2.properties, op2.newProperties)) return op1;
  var tOps = [];
  if (equalMarks(op1.properties, op2.properties)) {
    if (!equalMarks(op1.newProperties, op2.newProperties)) {
      tOps.push(op1.set("properties", op1.newProperties).set("newProperties", op2.newProperties));
    }
    var mergedNewProperties = mergeMarkProperties(op1.newProperties, op2.newProperties, side === "left");
    if (!equalMarks(op2.newProperties, mergedNewProperties)) {
      tOps.push(op1.set("properties", op2.newProperties).set("newProperties", mergedNewProperties));
    }
  } else if (equalMarks(op1.newProperties, op2.properties)) {
    tOps.push(op1);
    if (!equalMarks(op1.newProperties, op2.newProperties)) {
      tOps.push(op1.set("properties", op1.newProperties).set("newProperties", op2.newProperties));
    }
  } else {
    tOps.push(op1);
  }
  return tOps;
});
defineTransform("set_mark", "add_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("set_mark", "remove_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("set_mark", "set_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("set_mark", "set_selection", function (op1, op2, side) {
  return op1;
});

function transformAnnotation(annotationOp, op) {
  return transformOpRange(annotationOp, "annotation", op);
}
defineTransform("add_annotation", "insert_text", function (op1, op2, side) {
  return transformAnnotation(op1, op2);
});
defineTransform("add_annotation", "remove_text", function (op1, op2, side) {
  return transformAnnotation(op1, op2);
});
defineTransform("add_annotation", "split_node", function (op1, op2, side) {
  return transformAnnotation(op1, op2);
});
defineTransform("add_annotation", "merge_node", function (op1, op2, side) {
  return transformAnnotation(op1, op2);
});
defineTransform("add_annotation", "move_node", function (op1, op2, side) {
  return transformAnnotation(op1, op2);
});
defineTransform("add_annotation", "insert_node", function (op1, op2, side) {
  return transformAnnotation(op1, op2);
});
defineTransform("add_annotation", "remove_node", function (op1, op2, side) {
  return transformAnnotation(op1, op2);
});
defineTransform("add_annotation", "set_node", function (op1, op2, side) {
  return transformAnnotation(op1, op2);
});
defineTransform("add_annotation", "add_mark", function (op1, op2, side) {
  return transformAnnotation(op1, op2);
});
defineTransform("add_annotation", "remove_mark", function (op1, op2, side) {
  return transformAnnotation(op1, op2);
});
defineTransform("add_annotation", "set_mark", function (op1, op2, side) {
  return transformAnnotation(op1, op2);
});
defineTransform("add_annotation", "set_selection", function (op1, op2, side) {
  return transformAnnotation(op1, op2);
});
defineTransform("add_annotation", "add_annotation", function (op1, op2, side) {
  if (op1.annotation.key !== op2.annotation.key) return op1;

  // If two adds conflict, the winner will ignore the second one, and
  // the loser will run a set_annotation operation to replace itself
  // with the winning one.
  if (side !== "left") return [];
  var tOp = slate.Operation.create({
    type: "set_annotation",
    properties: slate.Annotation.createProperties(op2.annotation),
    newProperties: slate.Annotation.createProperties(op1.annotation)
  });
  tOp = updateOrRemove(tOp, ["data", "properties"], op2.data.get("annotation"));
  tOp = updateOrRemove(tOp, ["data", "newProperties"], op1.data.get("annotation"));
  return tOp;
});
defineTransform("add_annotation", "remove_annotation", function (op1, op2, side) {
  if (op1.annotation.key !== op2.annotation.key) return op1;

  // add vs remove always defers to the remove.
  return [];
});
defineTransform("add_annotation", "set_annotation", function (op1, op2, side) {
  if (op1.annotation.key !== op2.properties.key) return op1;

  // add vs set always defers to the set.
  return [];
});

function transformSetAnnotationOp(setAnnotationOp, op) {
  var tOp = setAnnotationOp;
  tOp = transformOpRange(tOp, "properties", op);
  tOp = transformOpRange(tOp, "newProperties", op);
  return tOp;
}
defineTransform("set_annotation", "insert_text", function (op1, op2, side) {
  return transformSetAnnotationOp(op1, op2);
});
defineTransform("set_annotation", "remove_text", function (op1, op2, side) {
  return transformSetAnnotationOp(op1, op2);
});
defineTransform("set_annotation", "split_node", function (op1, op2, side) {
  return transformSetAnnotationOp(op1, op2);
});
defineTransform("set_annotation", "merge_node", function (op1, op2, side) {
  return transformSetAnnotationOp(op1, op2);
});
defineTransform("set_annotation", "move_node", function (op1, op2, side) {
  return transformSetAnnotationOp(op1, op2);
});
defineTransform("set_annotation", "insert_node", function (op1, op2, side) {
  return transformSetAnnotationOp(op1, op2);
});
defineTransform("set_annotation", "remove_node", function (op1, op2, side) {
  return transformSetAnnotationOp(op1, op2);
});
defineTransform("set_annotation", "set_node", function (op1, op2, side) {
  return transformSetAnnotationOp(op1, op2);
});
defineTransform("set_annotation", "add_mark", function (op1, op2, side) {
  return transformSetAnnotationOp(op1, op2);
});
defineTransform("set_annotation", "remove_mark", function (op1, op2, side) {
  return transformSetAnnotationOp(op1, op2);
});
defineTransform("set_annotation", "set_mark", function (op1, op2, side) {
  return transformSetAnnotationOp(op1, op2);
});
defineTransform("set_annotation", "set_selection", function (op1, op2, side) {
  return transformSetAnnotationOp(op1, op2);
});
defineTransform("set_annotation", "add_annotation", function (op1, op2, side) {
  if (op1.properties.key !== op2.annotation.key) return op1;

  // Since the add has already happened, our old properties need to
  // match the current state of the annotation.
  var tOp = op1.set("properties", op2.annotation);
  return updateOrRemove(tOp, ["data", "properties"], op2.data.get("annotation"));
});
defineTransform("set_annotation", "remove_annotation", function (op1, op2, side) {
  if (op1.properties.key !== op2.annotation.key) return op1;

  // set after remove can have no effect
  return [];
});
defineTransform("set_annotation", "set_annotation", function (op1, op2, side) {
  if (op1.properties.key !== op2.properties.key) return op1;
  if (side !== "left") return [];

  // Since the set has already happened, our old properties need to
  // match the current state of the annotation.
  var mergedProperties = merge(op2.properties, op2.newProperties);
  var mergedData = merge(op2.data.get("properties") || {}, op2.data.get("newProperties") || {});
  var tOp = op1.set("properties", mergedProperties);
  tOp = updateOrRemove(tOp, ["data", "properties"], mergedData);
  return tOp;
});

function transformAnnotation$1(annotationOp, op) {
  return transformOpRange(annotationOp, "annotation", op);
}
defineTransform("remove_annotation", "insert_text", function (op1, op2, side) {
  return transformAnnotation$1(op1, op2);
});
defineTransform("remove_annotation", "remove_text", function (op1, op2, side) {
  return transformAnnotation$1(op1, op2);
});
defineTransform("remove_annotation", "split_node", function (op1, op2, side) {
  return transformAnnotation$1(op1, op2);
});
defineTransform("remove_annotation", "merge_node", function (op1, op2, side) {
  return transformAnnotation$1(op1, op2);
});
defineTransform("remove_annotation", "move_node", function (op1, op2, side) {
  return transformAnnotation$1(op1, op2);
});
defineTransform("remove_annotation", "insert_node", function (op1, op2, side) {
  return transformAnnotation$1(op1, op2);
});
defineTransform("remove_annotation", "remove_node", function (op1, op2, side) {
  return transformAnnotation$1(op1, op2);
});
defineTransform("remove_annotation", "set_node", function (op1, op2, side) {
  return transformAnnotation$1(op1, op2);
});
defineTransform("remove_annotation", "add_mark", function (op1, op2, side) {
  return transformAnnotation$1(op1, op2);
});
defineTransform("remove_annotation", "remove_mark", function (op1, op2, side) {
  return transformAnnotation$1(op1, op2);
});
defineTransform("remove_annotation", "set_mark", function (op1, op2, side) {
  return transformAnnotation$1(op1, op2);
});
defineTransform("remove_annotation", "set_selection", function (op1, op2, side) {
  return transformAnnotation$1(op1, op2);
});
defineTransform("remove_annotation", "add_annotation", function (op1, op2, side) {
  // remove vs add always defers to the remove
  return op1;
});
defineTransform("remove_annotation", "remove_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("remove_annotation", "set_annotation", function (op1, op2, side) {
  if (op1.annotation.key !== op2.properties.key) return op1;

  // Update the delete's properties with the new properties after the set
  var tOp = op1.set("annotation", op1.annotation.setProperties(merge(op2.properties, op2.newProperties)));
  tOp = updateOrRemove(tOp, ["data", "annotation"], op2.data.get("newProperties"));
  return tOp;
});

function transformSetSelectionOp(selectionOp, op) {
  var tOp = selectionOp;
  tOp = transformOpSelection(selectionOp, "properties", op);
  tOp = transformOpSelection(tOp, "newProperties", op);
  return tOp;
}
defineTransform("set_selection", "insert_text", function (op1, op2, side) {
  return transformSetSelectionOp(op1, op2);
});
defineTransform("set_selection", "remove_text", function (op1, op2, side) {
  return transformSetSelectionOp(op1, op2);
});
defineTransform("set_selection", "split_node", function (op1, op2, side) {
  return transformSetSelectionOp(op1, op2);
});
defineTransform("set_selection", "merge_node", function (op1, op2, side) {
  return transformSetSelectionOp(op1, op2);
});
defineTransform("set_selection", "move_node", function (op1, op2, side) {
  return transformSetSelectionOp(op1, op2);
});
defineTransform("set_selection", "insert_node", function (op1, op2, side) {
  return transformSetSelectionOp(op1, op2);
});
defineTransform("set_selection", "remove_node", function (op1, op2, side) {
  return transformSetSelectionOp(op1, op2);
});
defineTransform("set_selection", "set_node", function (op1, op2, side) {
  return op1;
});
defineTransform("set_selection", "add_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("set_selection", "remove_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("set_selection", "set_mark", function (op1, op2, side) {
  return op1;
});
defineTransform("set_selection", "add_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("set_selection", "remove_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("set_selection", "set_annotation", function (op1, op2, side) {
  return op1;
});
defineTransform("set_selection", "set_selection", function (op1, op2, side) {
  return op1;
});

// These methods let you build a transform function from a transformComponent
// function for OT types like JSON0 in which operations are lists of components
// and transforming them requires N^2 work. I find it kind of nasty that I need
// this, but I'm not really sure what a better solution is. Maybe I should do
// this automatically to types that don't have a compose function defined.

// Add transform and transformX functions for an OT type which has
// transformComponent defined.  transformComponent(destination array,
// component, other component, side)

function bootstrapTransform(type, transformComponent, append) {
  var transformComponentX = function transformComponentX(left, right, destLeft, destRight) {
    transformComponent(destLeft, left, right, "left");
    transformComponent(destRight, right, left, "right");
  };
  var transformX = type.transformX = function (leftOp, rightOp) {
    var newRightOp = [];
    for (var i = 0; i < rightOp.length; i++) {
      var rightComponent = rightOp[i];

      // Generate newLeftOp by composing leftOp by rightComponent
      var newLeftOp = [];
      var k = 0;
      while (k < leftOp.length) {
        var nextC = [];
        transformComponentX(leftOp[k], rightComponent, newLeftOp, nextC);
        k++;
        if (nextC.length === 1) {
          rightComponent = nextC[0];
        } else if (nextC.length === 0) {
          for (var j = k; j < leftOp.length; j++) {
            append(newLeftOp, leftOp[j]);
          }
          rightComponent = null;
          break;
        } else {
          // Recurse.
          var pair = transformX(leftOp.slice(k), nextC);
          for (var l = 0; l < pair[0].length; l++) {
            append(newLeftOp, pair[0][l]);
          }
          for (var r = 0; r < pair[1].length; r++) {
            append(newRightOp, pair[1][r]);
          }
          rightComponent = null;
          break;
        }
      }
      if (rightComponent != null) {
        append(newRightOp, rightComponent);
      }
      leftOp = newLeftOp;
    }
    return [leftOp, newRightOp];
  };

  // Transforms op with specified type ('left' or 'right') by otherOp.
  type.transform = function (op, otherOp, type) {
    if (!(type === "left" || type === "right")) throw new Error("type must be 'left' or 'right'");
    if (otherOp.length === 0) return op;
    if (op.length === 1 && otherOp.length === 1) return transformComponent([], op[0], otherOp[0], type);
    if (type === "left") return transformX(op, otherOp)[0];else return transformX(otherOp, op)[1];
  };
}

var debug$2 = Debug("ot-slate:type");
var serialize = function serialize(snapshot) {
  return snapshot.toJSON ? snapshot.toJSON({
    preserveAnnotations: true
  }) : snapshot;
};
var deserialize = function deserialize(data) {
  return slate.Value.fromJSON(data);
};
var applyAsync = function applyAsync(snapshot, ops, callback) {
  if (ops.length <= 0) {
    callback(snapshot);
  } else {
    var op = ops.shift();
    if (typeof window !== "undefined" && window.setImmediate || typeof global !== "undefined" && global.setImmediate) {
      setImmediate(applyAsync, applyOpToValue(snapshot, op), ops, callback);
    } else {
      setTimeout(function () {
        return applyAsync(applyOpToValue(snapshot, op), ops, callback);
      }, 0);
    }
  }
};
var apply = function apply(snapshot, ops) {
  if (debug$2.enabled) {
    debug$2("applying ".concat(JSON.stringify(ops), "\n  to ").concat(valueString(snapshot)));
  }
  if (ops.length > 0) {
    var lastOp = ops[ops.length - 1];
    if (lastOp.value) {
      // We've already calculated all the intermediate values -- we just
      // need the last one.

      if (debug$2.enabled) debug$2("  using cached ".concat(valueString(lastOp.value)));
      var newValue = applyOpToValue(lastOp.value, lastOp);
      if (debug$2.enabled) debug$2("  became ".concat(valueString(newValue)));
      return newValue;
    }
  }
  ops.forEach(function (op) {
    snapshot = applyOpToValue(snapshot, op);
  });
  if (debug$2.enabled) debug$2("  became ".concat(valueString(snapshot)));
  return snapshot;
};
var create = function create(initialData) {
  if (!initialData) {
    initialData = emptyDocument;
  }
  return initialData;
};
var composeComponent = function composeComponent(lastOp, op) {
  // Since the composed operation starts with lastOp, this always
  // needs to either return lastOp, or set the value of the returned
  // op to lastOp's value.
  if (lastOp.type === "insert_text") {
    if (op.type === "insert_text" && samePath(lastOp.path, op.path) && lastOp.offset + lastOp.text.length === op.offset) {
      return lastOp.set("text", lastOp.text + op.text);
    }
    if (op.type === "remove_text" && samePath(lastOp.path, op.path)) {
      var insertBounds = textOpBounds(lastOp);
      var removeBounds = textOpBounds(op);
      if (removeBounds.start >= insertBounds.start && removeBounds.end <= insertBounds.end) {
        if (op.text === lastOp.text.slice(removeBounds.start - insertBounds.start, removeBounds.end - insertBounds.start + 1)) {
          return lastOp.set("text", lastOp.text.slice(0, removeBounds.start).concat(lastOp.text.slice(removeBounds.end + 1, -1)));
        }
      }
    }
  }
  if (lastOp.type === "remove_text") {
    if (op.type === "remove_text") {
      if (samePath(lastOp.path, op.path)) {
        if (op.offset + op.text.length === lastOp.offset) {
          // backward delete
          return lastOp.set("text", op.text + lastOp.text).set("offset", op.offset);
        } else if (lastOp.offset + lastOp.text.length === op.offset) {
          // forward delete
          return lastOp.set("text", lastOp.text + op.text);
        }
      }
    }
  }
  return lastOp;
};
var compose = function compose(op1, op2) {
  return op1.concat(op2).reduce(function (acc, op) {
    if (acc.length > 0) {
      var lastOp = acc[acc.length - 1];
      lastOp = normalizeComponent(lastOp);
      op = normalizeComponent(op);
      var composedOp = composeComponent(lastOp, op);
      if (composedOp !== lastOp) {
        if (debug$2.enabled) {
          validateComponent(composedOp);
        }
        return acc.slice(0, -1).concat(composedOp);
      }
    }
    return acc.concat([op]);
  }, []);
};
var normalizeDocument = function normalizeDocument(editor, ops) {
  var lastOp = ops[ops.length - 1];
  var newValue = applyOpToValue(editor.value, lastOp);
  editor.setValue(newValue, {
    normalize: false
  });
  editor.flush();
  editor.withoutSaving(function (change) {
    return change.normalize();
  });
  var normalizingOps = editor.operations.filter(function (op) {
    return op.type !== "set_selection" && op.type !== "set_value";
  });
  if (debug$2.enabled) {
    debug$2("normalizing schema identifier: ".concat(schemaIdentifier(editor.value)));
    debug$2("normalizing with ".concat(JSON.stringify(normalizingOps)));
  }
  if (normalizingOps.size <= 0) return [];
  return normalizingOps.toArray();
};
var transformComponent = function transformComponent(dest, op1, op2, side) {
  op1 = normalizeComponent(op1);
  op2 = normalizeComponent(op2);
  var transformedOps = transform(op1, op2, side);
  append(dest, transformedOps);
  return dest;
};
var append = function append(dest, op) {
  if (!op) return;
  Array.isArray(op) ? op.forEach(function (e) {
    return dest.push(e);
  }) : dest.push(op);
};
var transformSelection = function transformSelection(selection, ops) {
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var data = {};
  return ops.reduce(function (selection, op) {
    return changeSelection(selection, data, function (cursor, cursorDetails) {
      var newCursor = transformCursor(cursor, cursorDetails, op);
      if (value) {
        newCursor = fixupCursorPosition(newCursor, cursorDetails, value);
      }
      return newCursor;
    });
  }, selection);
};
var type = {
  name: "slate",
  uri: "https://github.com/aha-app/ot-slate",
  apply: apply,
  applyAsync: applyAsync,
  compose: compose,
  composeComponent: composeComponent,
  create: create,
  normalizeOp: normalizeOp,
  normalizeDocument: normalizeDocument,
  serialize: serialize,
  deserialize: deserialize,
  transformCursor: transformCursor,
  transformSelection: transformSelection
};
var transformer = {};
bootstrapTransform(transformer, transformComponent, append);
type.transform = transformer.transform;

// Override the transformX method to support Slate
// normalization. After transforming the two sets of operations, we
// run normalize on the resulting values, and append any ops needed to
// normalize the doc to each side. These should be identical!  For
// example, if you have a two-node document, and Client 0 runs
// {remove_node, 0} and Client 1 runs {remove_node, 1}, Transformed 0
// becomes [{remove_node, 0}, {insert_node, 0}] and Transformed 1
// becomes [{remove_node, 0}, {insert_node, 0}]. This brings both
// sides into a consistent state, and normalizes the document.  NOTE:
// This means that all clients, including the ShareDB servers, must
// normalize documents in *exactly* the same way.
type.transformX = function (leftOp, rightOp) {
  var intermediateValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var editor = intermediateValues.editor;
  var startValue = editor && editor.value;
  var left;
  var right;
  try {
    var _transformer$transfor = transformer.transformX(leftOp, rightOp);
    var _transformer$transfor2 = _slicedToArray(_transformer$transfor, 2);
    left = _transformer$transfor2[0];
    right = _transformer$transfor2[1];
  } catch (e) {
    console.error("Error during transformation");
    if (debug$2.enabled) {
      debug$2(operationHistory(startValue, leftOp, rightOp));
    }
    throw e;
  }

  // If we didn't have a value to start with, there's nothing to
  // normalize.
  if (!startValue) {
    return [left, right];
  }
  var normalizingOps;
  try {
    // We use op.apply to apply operations pre-normalization, so we
    // have to ensure that these op lists are actual Operation
    // objects.
    leftOp = normalizeOp(leftOp);
    rightOp = normalizeOp(rightOp);

    // If we were passed a value, fix up all of the operations so they'd
    // correctly apply to the resulting value after all of the
    // non-transformed operations succeed. This is necessary to support
    // undo / redo of remove_node and set_selection operations.
    var leftValue = apply(startValue, leftOp);
    intermediateValues.leftValue = leftValue;
    right = fixupOperations(leftValue, right);
    var rightValue = apply(startValue, rightOp);
    intermediateValues.rightValue = rightValue;
    left = fixupOperations(rightValue, left);

    // At this point, we're guaranteed that
    //
    // apply(lastValue(leftOp + right), right[right.length - 1]) ===
    // apply(lastValue(rightOp + left), left[left.length - 1])
    //
    // Otherwise, there had to have been a bug in transformation.  So,
    // we can do any normalization we need on the left value, and then
    // just use the same normalizing operations on both lists.

    // Fast-forward to the second-to-last value.
    var allOps = rightOp.concat(left);
    var lastValue = apply(startValue, allOps.slice(0, -1));
    editor.setValue(lastValue, {
      normalize: false
    });
    normalizingOps = normalizeDocument(editor, allOps);
    var normalizedLeft = left.concat(normalizingOps);
    var normalizedRight = right.concat(normalizingOps);
    intermediateValues.endValue = apply(lastValue, allOps.slice(-1).concat(normalizingOps));
    return [normalizedLeft, normalizedRight];
  } catch (e) {
    console.error("Error generating normalizing operations");
    if (debug$2.enabled) {
      debug$2(operationHistory(startValue, leftOp, rightOp, left, right));
    }
    throw e;
  }
};

exports.type = type;
